module.exports = __webpack_public_path__ + "static/media/accelerate-small.bfeb8e1b.svg";